
import React ,{useState}from "react"; 
import { Select } from "antd";
import Breadcrumb from "../Breadcrumb";
import useFetch from "../../../../commons/useFetch";
function Filter(props) {
  const { Option } = Select;

  const Services=[{
      id:1,
      code:"LO",
      name:"Lounge"
  },{
      id:1,
      code:"GY",
      name:"Gym"
  },{
      id:1,
      code:"EV",
      name:"Event"
  },{
      id:1,
      code:"RM",
      name:"Phòng"
  },{
      id:1,
      code:"OT",
      name:"Other"
  }]
  const {data : provinces}=useFetch('https://provinces.open-api.vn/api/')
  return (
    <div className="filterHotels">
      <div className="container">
          
        <div className="filterContent">
            <div className="formLocation">
              <Select
                showSearch
                defaultValue="all"
                optionFilterProp="children"
                filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={(value)=>props.onChangeService(value)}
                >
                <Option value="all">Tất cả</Option>
                {Services && Services.map((option) => (
                <Option value={option.code} key={option.code}>
                {option.name}
                </Option>
                ))}
                </Select>
              
            </div>
            <div className="formLocation">
                <Select 
                showSearch
                defaultValue="all"
                optionFilterProp="children"
                filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={(value)=>props.onchangeProvince(value)}
              >
                <Option value="all">Tất cả</Option>
                {provinces && provinces.map((option) => (
                  <Option value={option.codename} key={option.codename}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </div>
        </div>    
      </div>
    </div>
  );
}
export default Filter;
